module.exports = __webpack_public_path__ + "img/desert-level.56f0d819.png";